module.exports = __webpack_public_path__ + "media/your_career_track/personal-chef-hover-27f58838.png";